import React, { useMemo } from 'react';

import adminApiClient from 'api/adminApiClient';
import {
  getFileUploadMessages,
  mapS3UploadFilesToDownloadResponseModel,
} from 'utils/fileUtils';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import { generateUploadFileList } from 'utils/fileUtils';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';
import { FileValue } from 'components/wrappers/BaseFileUpload';
import { MEMBER_PRICE_AGREEMENT_MAX_FILES } from 'constants/fileUploadLimits';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];
const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  defaultFile?: FileValue[];
};

export default React.memo((props: Props) => {
  const { defaultFile = [] } = props;

  const defaultFileList = useMemo(() => {
    const mappedFilesToCorrectModel =
      mapS3UploadFilesToDownloadResponseModel(defaultFile);

    return defaultFile ? generateUploadFileList(mappedFilesToCorrectModel) : [];
  }, [defaultFile]);

  return (
    <FormikFileUpload
      name="agreementPath"
      defaultFileList={defaultFileList}
      isDraggable
      includeFileName
      maxFileCount={MEMBER_PRICE_AGREEMENT_MAX_FILES}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      uploadLinkFunction={adminApiClient.getPriceAgreementUploadLink.bind(
        adminApiClient,
      )}
    >
      {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
    </FormikFileUpload>
  );
});
